<template>
    <div class="out-box">
        <div class="inner-box" style="">
            <el-upload
                    drag
                    ref="upload"
                    :action="actionUrl"
                    :data="actionQuery"
                    :on-success="uploadImgSuccess"
                    :on-change="fileChange"
                    accept=".jpg,.png,">
                <div class="el-upload__text" style="margin: 60px 0 0 0;color: rgba(0, 0, 0, 0.4)">
                    <p>将文件拖到此处，或<em>点击上传</em></p>
                    <p>只能上传jpg/png文件，且不超过7M</p>
                </div>
            </el-upload>
        </div>
        <label v-if="backgroundType == 1" class="show-img do-business">
            <img v-if="picShow" :src="imgShow" alt="">
        </label>
        <label v-if="backgroundType == 2" class="show-img id-card-positive">
            <img v-if="picShow" :src="imgShow" alt="">
        </label>
        <label v-if="backgroundType == 3" class="show-img id-card-another">
            <img v-if="picShow" :src="imgShow" alt="">
        </label>
        <label v-if="backgroundType == 4" class="show-img basic-scanning">
            <img v-if="picShow" :src="imgShow" alt="">
        </label>
        <label v-if="backgroundType == 5" class="show-img qualification-certificate">
            <img v-if="picShow" :src="imgShow" alt="">
        </label>
        <div class="img-preview" @click="openImgPreview" v-if="picShow">
            预览
        </div>
        <el-dialog
                :title="backgroundTypeTransformation(backgroundType)"
                :visible.sync="centerDialogVisible"
                width="50%"
                height="60%"
                center>
            <span style="display: flex;align-items: center;justify-content: center">
                 <img ref="rotateImg" v-if="picShow" :src="imgShow" style="width: 90%" alt="">
            </span>
            <div style="display: flex;align-items: center;justify-content: space-between">
                <el-button @click="rotate(0)">左旋转</el-button>
                <el-button @click="rotate(1)">右旋转</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
    export default {
        props: {
            orgAbovePhotoAddr: {
                type: String,
            },
            orgBelowPhotoAddr: {
                type: String,
            },
            businessPhotoAddr: {
                type: String,
            },
            bankPhotoAddr: {
                type: String,
            },
            backgroundType: {
                type: Number,
            },
            ruleForm: {
                type: Object
            }
        },
        data() {
            return {
                centerDialogVisible:false,
                actionUrl: '',
                actionQuery: {},//action参数
                picShow: '',
                imgShow: '',
                fileInfo:{
                    deg:0
                }
            }
        },
        created() {
            this.actionUrl = '/proxyApi/sys/upload/uploadFile.do';
        },
        mounted(){
            this.$nextTick(()=>{
                if(this.businessPhotoAddr != '' && this.businessPhotoAddr != undefined){
                    this.getImgUrl(this.businessPhotoAddr);
                }
                if(this.orgAbovePhotoAddr != '' && this.orgAbovePhotoAddr != undefined){
                    this.getImgUrl(this.orgAbovePhotoAddr);
                }
                if(this.orgBelowPhotoAddr != '' && this.orgBelowPhotoAddr != undefined){
                    this.getImgUrl(this.orgBelowPhotoAddr);
                }
                if(this.bankPhotoAddr != '' && this.bankPhotoAddr != undefined){
                    this.getImgUrl(this.bankPhotoAddr);
                }
            })
        },
        methods: {
            getImgUrl(filePath){
                this.$http({
                    method: 'get',
                    url: '/sys/upload/downfile?filePath=' + filePath,
                    responseType: 'blob'
                }).then(res => {
                    var typeName = filePath.split(".")[1];
                    let blob = new Blob([res.data], {type: 'application/' + typeName + ''})
                    this.imgShow = window.URL.createObjectURL(blob);
                    this.picShow = true;
                })
            },
            //上传触发
            fileChange(file) {
                this.actionQuery.file1 = file.raw;
                this.actionQuery.table = 'basic';
                let fd = new FormData();
                fd.append('file1', file.raw);
                if (this.backgroundType == 1) { //判断为营业执照
                    this.$http.post('/ocr/getBizLicenseOCR', fd).then(res => {
                        console.log(res)
                        if (res.data.code == 1 && !!res.data.data) {
                            let data = res.data.data;
                            this.ruleForm.certNum = data.certNum;
                            this.ruleForm.businessFailTime = data.businessFailTime.replace(/-/g,'/');
                            this.ruleForm.registerCapital = data.registerCapital;
                            this.ruleForm.incorporationTime = data.incorporationTime.replace(/-/g,'/');
                            this.ruleForm.address = data.address;
                            this.ruleForm.businessScope = data.businessScope;
                            this.ruleForm.certName = data.entName;
                            this.ruleForm.unitProperty = data.unitProperty;
                        }
                    })
                }else if(this.backgroundType == 2){//判断为身份证
                    this.$http.post('/ocr/getIdCardOCR', fd).then(res => {
                        if (res.data.code == 1 && !!res.data.data) {
                            let data = JSON.parse(res.data.data);
                            this.ruleForm.orgLegal = data.Name ? data.Name : '';
                            this.ruleForm.legalIdCard = data.IdNum ? data.IdNum : '';
                        }
                    })
                }else if(this.backgroundType == 4) {//判断为基本户扫描件
                    this.$http.post('/ocr/getIdBankCardOCR', fd).then(res => {
                        if (res.data.code == 1 && !!res.data.data) {
                            let data = res.data.data;
                            this.ruleForm.mainBank = data.bankInfoType ? data.bankInfoType : '';
                            this.ruleForm.amountNum = data.certNum ? data.certNum : '';
                        }
                    })
                }
                // 取消资质证书的ocr识别
                // }else if(this.backgroundType == 5){//判断为资质证书
                //     this.$http.post('/ocr/getEnterpriseLicenseOCR',fd).then(res => {
                //         if(res.data.code == 1){
                //             // console.log(JSON.parse(res.data.data))
                //             let data = res.data.data;
                //             console.log(JSON.parse(res.data.data))
                //         }
                //     })
                // }
                this.$emit('update:ruleForm', this.ruleForm);//更新父组件视图
            },
            //上传成功
            uploadImgSuccess(file) {
                if (file.code == 1) {
                    this.$refs.upload.clearFiles(); //去掉文件列表
                    this.$emit('update:businessPhotoAddr', file.data.filepath);
                    this.$emit('update:orgAbovePhotoAddr', file.data.filepath);
                    this.$emit('update:orgBelowPhotoAddr', file.data.filepath);
                    this.$emit('update:bankPhotoAddr', file.data.filepath);
                    this.$http({
                        method: 'get',
                        url: '/sys/upload/downfile?filePath=' + file.data.filepath,
                        responseType: 'blob'
                    }).then(res => {
                        var typeName = file.data.extendName.replace('.', '')
                        let blob = new Blob([res.data], {type: 'application/' + typeName + ''})
                        this.imgShow = window.URL.createObjectURL(blob);
                        this.picShow = true;
                        this.$notify({
                            title: '上传',
                            message: '图片上传成功',
                            position: 'bottom-right',
                            type: 'success'
                        })
                    })
                }
            },
            openImgPreview(){
                this.centerDialogVisible = true;
            },
            //backgroundType 图片上传组件背景参数 1-> 营业执照 2-> 身份证正面 3-> 身份证反面 4-> 基本户扫描件 5-> 资质证书
            backgroundTypeTransformation(val){
                switch(val){
                    case 1 : return '营业执照' ; break;
                    case 2 : return '身份证正面' ; break;
                    case 3 : return '身份证反面' ; break;
                    case 4 : return '基本户扫描件' ; break;
                    case 5 : return '资质证书' ; break;
                    default : return '' ; break;
                }
            },
            rotate (val) {
                if(val == 0){
                    console.log('left')
                    this.fileInfo.deg -= 90;
                    if (this.fileInfo.deg <= -360) {
                        this.fileInfo.deg = 0
                    }
                }else{
                    this.fileInfo.deg += 90;
                    if (this.fileInfo.deg >= 360) {
                        this.fileInfo.deg = 0
                    }

                }
                this.$refs.rotateImg.style.transform = `rotate(${this.fileInfo.deg}deg)`;
                this.$refs.rotateImg.style.width = '70%';
                this.$refs.rotateImg.style.height = '70%';
            }
        },
    }
</script>
<style lang="scss" scoped>
    /deep/.el-upload-dragger{
        width: 300px;
        height: 186px;
        background: rgba(255,255,255,0);
        .is-dragover{
            background: rgba(0, 0, 0, 0.3);
        }
    }
    .out-box {
        width: 300px;
        height: 186px;
        position: relative;
        margin: 0 0 48px 0;
        .inner-box {
            width: 100%;
            height: 100%;
            position: absolute;
            left: 0;
            top: 0;
            /*opacity: 0.3;*/
            z-index: 99;
        }
        .inner-box:hover{
            background: rgba(0, 0, 0, 0.3);
        }
        .show-img {
            display: inline-block;
            width: 300px;
            height: 186px;
            cursor: pointer;
            position: absolute;
            top: 0;
            img {
                width: 100%;
                height: 100%;
            }
        }

        .do-business {
            background: url("../../assets/img/yingyezhizhao.png") no-repeat center center;
        }

        .id-card-positive {
            background: url("../../assets/img/id-card-positive.png") no-repeat center center;
        }

        .id-card-another {
            background: url("../../assets/img/id-card-another.png") no-repeat center center;
        }

        .basic-scanning {
            background: url("../../assets/img/basic-scanning.png") no-repeat center center;
        }

        .qualification-certificate {
            background: url("../../assets/img/qualification-certificate.png") no-repeat center center;
        }
        .img-preview{
            width: 50px;
            position: absolute;
            left: 270px;
            bottom: -40px;
            font-size: 14px;
            color: #1890FF;
            cursor: pointer;
        }
    }

    @media screen and (max-width: 1600px){
        .out-box{
            width: 200px;
            height: 140px;
            .show-img{
                width: 200px;
                height: 140px;
            }
            .img-preview{
                left: 170px;
                bottom: -40px;
            }
            /deep/.el-upload-dragger{
                width: 200px;
                height: 140px;
            }
        }
    }
</style>